import { RequestStatus } from '@upright/ui/api/common/types';
import {
  clientDatumSourceDescription,
  toSimplifiedSource,
} from '@upright/ui/common/upright/core/impact-lenses/insights/source-description/source-description';
import { useTargetsLensContext } from '@upright/ui/common/upright/core/impact-lenses/targets/common/use-targets-lens-context';
import Skeleton from 'react-loading-skeleton';

export function TargetsSourceDescription() {
  const ctx = useTargetsLensContext();
  if (!ctx) {
    return <></>;
  }
  const data = ctx.data;
  if (data.loadingStatus === RequestStatus.LOADING) {
    return <Skeleton width="5.0em" />;
  }
  const items = data.targets;
  if (!items) {
    return <>Error</>;
  }
  return <>{clientDatumSourceDescription(toSimplifiedSource(items))}</>;
}
